import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useQueryClient } from '@tanstack/react-query';
import type { AppDispatch } from '../../../redux/store';
import { logout as reduxLogout } from '../../../redux/auth';
import { resetMenu } from '../../../redux/Menu';
import { clearCache } from '../../../APIs/menuAPI';
import { useTabAuth } from '../../../hooks/useTabAuth';

export const Logout: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const queryClient = useQueryClient();
  const { logout: tabAuthLogout } = useTabAuth();

  useEffect(() => {
    // Clear all three caching layers so the next user sees fresh data
    clearCache();                  // Layer 1: manual in-memory Map cache (menuAPI.js)
    queryClient.clear();           // Layer 2: React Query in-memory cache
    dispatch(resetMenu());         // Layer 3: Redux menu state
    dispatch(reduxLogout());
    tabAuthLogout();
    navigate('/login', { replace: true });
  }, [dispatch, tabAuthLogout, navigate, queryClient]);

  return null;
};
